import { PageRender } from "@/components/layout/frontend/page"

/**
 * Page: DataProtection
 */
const DataProtection: React.FC = () => {
  return <PageRender pageKey="dataProtection" />
}
export default DataProtection
